import { productFragment, productFragmentNormal } from '../fragments'

export const productsByTypeAndProgress = /* GraphQL */ `
  query ProductsByTypeAndProgress(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByTypeAndProgress(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items {
        ...productStatus
      }
    }
  }
  ${productFragment}
`
export const getProductAndStatusQuery = /* GraphQL */ `
  query GetProduct($id: ID!, $limit: Int) {
    getProduct(id: $id) {
      status(sortDirection: DESC, limit: $limit) {
        items {
          ...productStatus
        }
      }
    }
  }
  ${productFragmentNormal}
`

export const searchProductQuery = /* GraphQL */ `
  query searchProduct(
    $location: LocationInput
    $distance: Int
    $filter: SearchProductFilterInput
    $sort: SearchProductSortInput
    $nextToken: Int
    $limit: Int
  ) {
    searchProduct(
      location: $location
      distance: $distance
      filter: $filter
      sort: $sort
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        ...productStatus
      }
      total
      nextToken
    }
  }
  ${productFragment}
`

export const searchProductStatusV2Query = /* GraphQL */ `
  query searchProductStatusV2(
    $location: LocationInput
    $distance: Int
    $filter: SearchProductFilterInput
    $sort: SearchProductSortInput
    $nextToken: Int
    $limit: Int
  ) {
    searchProductStatusV2(
      location: $location
      distance: $distance
      filter: $filter
      sort: $sort
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        ...productStatus
      }
      total
      nextToken
    }
  }
  ${productFragment}
`

export const searchProductTotalQuery = /* GraphQL */ `
  query searchProductStatusV2Total($filter: SearchProductFilterInput) {
    searchProductStatusV2(filter: $filter, limit: 1) {
      total
    }
  }
`
